export default "__VITE_ASSET__008e11f7__"